import React from 'react'
import {Helmet} from "react-helmet";
import {SEOItems} from "../../typings/interfaces/practice-front-node.interface";

const defaultTitle = 'Landing Page'
const defaultDescription = 'Beautiful website'
const defaultKeywords = 'Docspace,website'
const defaultOGURL = ''
const defaultOGImage = '/public/corgi.png'

const Head:React.FC<{seoSettings: SEOItems,subdomain:string | undefined}> = ({seoSettings,subdomain}) => (
    <Helmet>
        <meta charSet="utf-8" />
        <title>{seoSettings?.siteTitle || subdomain}</title>
        <meta name="description" content={seoSettings?.siteDescription || "Best website in the world"} />
        <meta name='keywords' content={seoSettings?.siteKeywords || defaultKeywords} />

        <link rel='shortcut icon' href={seoSettings?.siteFavIcon || defaultOGImage} />
        <link rel='icon' type='image/x-icon' href={seoSettings?.siteFavIcon || '/public/corgi.png'} />
        <link rel='apple-touch-icon' sizes='76x76' href={seoSettings?.siteFavIcon || ''} />
        <link rel='icon' type='image/png' sizes='32x32' href={seoSettings?.siteFavIcon || ''} />
        <link rel='icon' type='image/png' sizes='16x16' href={seoSettings?.siteFavIcon || ''} />
        <link rel='mask-icon' href='/public/safari-pinned-tab.svg' color='#5bbad5' />
        <meta name='msapplication-TileColor' content='#da532c' />
        <meta name='theme-color' content='#ffffff' />


        <meta property='og:url' content={seoSettings?.siteFavIcon|| defaultOGURL} />
        <meta property='og:title' content={seoSettings?.siteTitle || defaultTitle} key={seoSettings?.siteTitle}/>
        <meta property='og:description' content={seoSettings?.siteDescription || defaultDescription} />
        <meta property='og:image' content={seoSettings?.siteFavIcon || defaultOGImage} />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='630' />
        <meta name='twitter:title' content={seoSettings?.siteTitle || defaultTitle} key={seoSettings?.siteTitle}/>
        <meta name='twitter:description' content={seoSettings?.siteDescription || defaultDescription} />
        <meta name='twitter:site' content={seoSettings?.siteFavIcon || defaultOGURL} />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:image'
              content={seoSettings?.siteFavIcon || defaultOGImage} />

        {/*{seoSettings && seoSettings.googleAnalyticsTrackingCode && <>*/}
        {/*    <script*/}
        {/*        async*/}
        {/*        src={`https://www.googletagmanager.com/gtag/js?id=${seoSettings.googleAnalyticsTrackingCode}`}*/}
        {/*    />*/}
        {/*    <script*/}
        {/*        dangerouslySetInnerHTML={{*/}
        {/*            __html: `*/}
        {/*    window.dataLayer = window.dataLayer || [];*/}
        {/*    function gtag(){dataLayer.push(arguments);}*/}
        {/*    gtag('js', new Date());*/}
        {/*    gtag('config', '${seoSettings.googleAnalyticsTrackingCode}', {*/}
        {/*      page_path: window.location.pathname,*/}
        {/*    });*/}
        {/*  `,*/}
        {/*        }}*/}
        {/*    />*/}
        {/*</>}*/}
    </Helmet>
)
export default Head;
